__turbopack_context__.v({
  "authContent": "C8ZyHG_authContent",
  "card": "C8ZyHG_card",
  "centeredAction": "C8ZyHG_centeredAction",
  "checkEmail": "C8ZyHG_checkEmail",
  "codeInputContainer": "C8ZyHG_codeInputContainer",
  "divider": "C8ZyHG_divider",
  "error": "C8ZyHG_error",
  "fieldRow": "C8ZyHG_fieldRow",
  "footer": "C8ZyHG_footer",
  "form": "C8ZyHG_form",
  "formActions": "C8ZyHG_formActions",
  "formActive": "C8ZyHG_formActive",
  "formRow": "C8ZyHG_formRow",
  "forms": "C8ZyHG_forms",
  "globalError": "C8ZyHG_globalError",
  "header": "C8ZyHG_header",
  "socialLogin": "C8ZyHG_socialLogin",
  "subtitle": "C8ZyHG_subtitle",
  "success": "C8ZyHG_success",
  "switchCopy": "C8ZyHG_switchCopy",
  "tabButton": "C8ZyHG_tabButton",
  "tabList": "C8ZyHG_tabList",
  "tabs": "C8ZyHG_tabs",
  "title": "C8ZyHG_title",
});
